import { useEffect, useState } from 'react'
import './app-footer.scss'
import { useLocation } from 'react-router-dom'

const AppFooter = () => {
  const location = useLocation()

  /**
   * This logic serves to hide the footer till the rest of the elements are loaded.
   * Will revert once we figure how to control the initial render
   * See PR for reference - https://dev.azure.com/PSJH/Providence%20Global%20Center/_git/P2P-UI/pullrequest/66502?_a=files
   */

  const [delayed, setDelayed] = useState(false)
  useEffect(() => {
    setTimeout(() => {
      setDelayed(true)
    }, 1_000)
  })

  if (!delayed) {
    return null
  }
  //
  return (
    <footer
      className={`app-footer bg-theme-blue md:flex flex-col md:flex-row items-center justify-between p-1 px-7 md:fixed md:bottom-0 left-0 w-full z-[1000] ${
        location.pathname !== '/' ? 'hidden md:flex' : 'flex'
      }`}
    >
      <div className="flex text-white justify-start">
        Contact : p2p@providence.org
      </div>
      <div className="flex text-white text-xs text-center py-1 px-2 flex-1 mx-4">
        Confidential, Privileged, and Protected pursuant to the Patient Safety
        and Quality Improvement Act of 2005, 42 U.S.C. § 299b-21, et seq., its
        attendant regulations, and other state and federal laws including: AS
        §§18.23.005 – 18.23.070; RCWs 70.41.200, 43.70.510, 4.24.250; ORS 41.675
        and ORS 441.685; Cal Evid. Code §1157; MCA §§37-3-404(6), 50-16-202 and
        50-16-203, Tex. Health & Safety Code Ann. § 161.032 and § 161.033; N.M
        Stat. Ann. §41-9-241-9-1 to 41-9-7, and as amended.
      </div>
      <div className="flex text-white align-middle items-center py-1">
        &copy;2026 P2P. All rights reserved.
      </div>
    </footer>
  )
}

export default AppFooter
